import {Utils} from './Utils';

class AssetPreloader{
    static preloadedFiles=[];
    
    static mustLoadFiles(filesArray){
        let ret=[];
        for (let i=0;i<filesArray.length;i++){
            if (this.preloadedFiles.indexOf(filesArray[i])>=0){    
            }else{
                ret.push(filesArray[i]);
            }
        }
        return ret;
    }
    
    static preloadFiles(filesArray,progressCallback, completeCallback, errorCallback, stopOnError){
        filesArray=this.mustLoadFiles(filesArray);
        let self=this;
        let p=new Preloader();
        p.stopOnError=stopOnError;
        p.onFileSuccessCB=function(file){
            //self.preloadedFiles.push(file);
            self.filePreloaded(file);
        };
        p.onFileErrorCB=function(file){
        };
        p.load(filesArray,progressCallback,completeCallback,errorCallback);
    }
    
    static filePreloaded(path){
        this.preloadedFiles.push(path);
        
    }
}


class Preloader{
    
    constructor(){
        this.filesToLoad=null;
        this.progressCallback=null;
        this.completeCallback=null;
        this.errorCallback=null;

        this.onFileSuccessCB=null;
        this.onFileErrorCB=null;

        this.index=0;
        this.totalFiles=0;
        this.currentFile="";
        this.stopOnError=false;
    }
    
    
   load(filesToLoad, progressCallback, completeCallback, errorCallback){
        this.filesToLoad=filesToLoad;
        this.progressCallback=progressCallback;
        this.completeCallback=completeCallback;
        this.errorCallback=errorCallback;
        this.totalFiles=this.filesToLoad.length;
        this.preloadNextFile();
    }
    
    preloadNextFile(){
        let self=this;
        if (this.index<this.totalFiles){
            this.currentFile=this.filesToLoad[this.index];

            this.onCurrentFileProgress(0);
            let extension=Utils.getFileExtension(this.currentFile);
            if (extension=="jpg" || extension=="png" || extension=="svg" || extension=="webp" || extension=="gif"){
                let img = new Image();
                img.onload=function(){
                    self.onCurrentFileComplete();
                };
                img.onerror=function(){
                    self.onCurrentFileError("Image error");
                };
                img.src=this.currentFile;
            }else if (extension=="js"){
                let script = document.createElement('script');
                script.type = 'text/javascript';
                
                script.onload=function(){
                    self.onCurrentFileComplete();
                };
                script.onerror=function(){
                    self.onCurrentFileError("Script error");
                };
                script.src = this.currentFile;
                document.body.appendChild(script);
            }else{
                let loader = new XMLHttpRequest();
                loader.onloadend=function(){
                    if (this.status==200){
                        self.onCurrentFileComplete();
                    }else{
                        self.onCurrentFileError();
                    }
                };
                loader.open('GET', this.currentFile+"", true);
                loader.send();
            }
        }else{
            if (this.completeCallback){
                this.completeCallback();
            }
        }
    }
    
    
    onCurrentFileProgress(pc){
        let filePc=1/this.totalFiles;
        let prevPc=filePc*this.index;
        let percent=prevPc+filePc*pc;
        if (this.progressCallback){
            this.progressCallback(percent,this.index,this.totalFiles);
        };
    }
    
    
    onCurrentFileComplete(e){
        let self=this;
        let extension=Utils.getFileExtension(this.currentFile);
        let timeOutTime=20;
        
        /*if (extension=="js"){
            window.onJSScriptLoaded=function(){
                self.onCurrentFileIncluded();
            };
            let head = document.getElementsByTagName('head')[0];
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = this.currentFile;
            head.appendChild(script);
            timeOutTime=1000;
        };*/
        this.onCurrentFileProgress(1);
        this.index++;
        
        this.timer=setTimeout(function(){
            self.onCurrentFileIncluded();
        },timeOutTime);
    }
    
    
    
    onCurrentFileIncluded(){
        clearTimeout(this.timer);
        window.onJSScriptLoaded=null;
        if (this.onFileSuccessCB){
            this.onFileSuccessCB(this.currentFile);
        }else{
            AssetPreloader.filePreloaded(this.currentFile);
        }
        this.preloadNextFile();
    }
    
    onCurrentFileError(e){
        if (this.onFileErrorCB){
            this.onFileErrorCB(this.currentFile);
        }
        if (this.stopOnError){
            if (this.errorCallback){
                this.errorCallback("Error loading file "+this.currentFile);
            }
        }else{
            this.onCurrentFileProgress(1);
            this.index++;
            this.preloadNextFile();
        }
    }
}

export {AssetPreloader, Preloader};